module.exports = __webpack_public_path__ + "static/img/logo-dajin.1da6d17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-dajin.jpg
// module id = wV5x
// module chunks = 1